import React from 'react';

const BackToTop = () => {
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button 
      onClick={scrollToTop}
      className="btn btn-lg btn-primary btn-lg-square back-to-top"
      style={{ border: 'none' }}
    >
      <i className="bi bi-arrow-up"></i>
    </button>
  );
};

export default BackToTop;